/**
 * styles.ts
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { css } from '@emotion/react';

export const styles = {
  container: css({
    
  }),

  option: css({
    flexGrow: 1,
    width: '100%',
    outline:      'none',
    border:       'none',
    fontWeight:   '500',
      fontSize: '16px',
    lineHeight:   '24px',
    display:      'flex',
    alignItems:  'center',
    justifyContent: 'left',
    borderRadius: 5,
    gap: '8px',
    padding:      '16px',
    color:     'rgb(0, 0, 0)',
    backgroundColor: 'rgb(255, 255, 255)',
    boxShadow: '0 0 0 1px inset rgb(0, 0, 0)',
    transition: 'color .2s, background-color .2s, box-shadow .2s',
    marginBottom: '12px',

    ':before': {
      display: 'none',
    },

    ':after': {
      display: 'none',
    },

    ':hover': {
      boxShadow: '0 0 0 2px inset rgb(0, 0, 0)',
    },

    'input': {
      appearance: 'none',
      display: 'block',
      border: '1px solid rgb(0, 0, 0)',
      background: 'transparent',
      width: '20px',
      height: '20px',
      borderRadius: '2px',
      position: 'relative',
      cursor: 'pointer',
      top: 0,
      bottom: 0,

      ':checked': {
        backgroundColor: 'rgb(56, 59, 74)',
        borderColor: 'rgb(56, 59, 74)',
      }
    }
  }),

  check: css({
    width: '20px',
    height: '20px',
    color: 'rgb(255, 255, 255)',
    position: 'relative',
    
    'svg': {
      position: 'absolute',
      top: '0',
      left: '0',
    },
  }),

  active: css({
    color: 'rgb(0, 0, 0)',
    backgroundColor: 'rgba(236, 236, 239, 1)',
    boxShadow: '0 0 0 2px inset rgb(56, 59, 74)',
  })
}